import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import { ImageUrls } from "src/app/services/s3buket";
import { HttpParams } from "@angular/common/http";
import { JobApplyService } from "src/app/jobseeker-component/job-apply/service/job-apply.service";

@Component({
  selector: "app-job-detail",
  templateUrl: "./job-detail.component.html",
  styleUrls: ["./job-detail.component.css"]
})
export class JobDetailComponent implements OnInit {
  jobsData: any = [];
  modalScrollDistance = 2;
  modalScrollThrottle = 50;
  limit = 5;
  skip = 1;
  totalCount: any;
  noData: any = false;
  jobID: any;
  jobDetailsData: any;
  extraParams: any;
  recruiterImagePath = ImageUrls.BaseUrl + ImageUrls.directories.recruiter;

  jobsType?: string;

  constructor(public route: ActivatedRoute, private router: Router, private api: AdminService,
    private jobApplyService: JobApplyService) { }

  ngOnInit(): void {
    this.jobID = this.route.snapshot.paramMap.get("id")
    this.route.queryParams.subscribe((params) => {
      if (params.type) {
        this.jobsType = params.type;
        if (this.jobsType == "roles") {
          this.extraParams = params.extras
          this.getJobs(this.extraParams);
        } else if (this.jobsType == "search") {
          this.extraParams = params.extras;
          this.getSearchData(JSON.parse(this.extraParams));
        }
        else {
          this.getAppliedJobs();
        }
      } else {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = "reload";
        this.router.navigate(["dashboard-job"]);
      }
    })
    this.getJobDetail();
  }

  getAppliedJobs() {
    let params = new HttpParams();
    params = params.append("skip", this.skip.toString());
    params = params.append("limit", this.limit.toString());
    let apiName;
    switch (this.jobsType) {
      case "roles":
        apiName = apiUrl._industryJobs;
        break; 
    }
    this.api.getData(apiName, params).subscribe(async (res) => {
      switch (this.jobsType) {
        case "roles":
          this.jobsData = res.data.data;
          break;
      }
      this.totalCount = res.data.count;
      this.noData = true;
    })
  }

  getJobs(categoryId) {
    const data = {
      "skip": this.skip.toString(),
      "limit": this.limit.toString(),
      "categoryId": [categoryId]
    }
    this.api.postData(apiUrl._industryJobs, data).subscribe((res) => {
      this.jobsData = res.data.listing;
      this.totalCount = res.data.count;
      this.noData = true;
    })
  }

  getSearchData(selectedFilters: any) {
    var request = Object.keys(selectedFilters).
      filter((key) => selectedFilters[key] instanceof Array ? selectedFilters[key].length > 0 : selectedFilters[key] != null).
      reduce((cur, key) => { return Object.assign(cur, { [key]: selectedFilters[key] }) }, {});
    this.api.postData(apiUrl._searchFilterJobs, request).subscribe((x) => {
      this.jobsData = x.data.listing;
      this.totalCount = x.data.count;
      this.noData = true;
    })
  }

  /** Infinite Scroll */
  onScrollDown() {
    console.log("scrolled down!!");
  }
  onModalScrollDown() {
    this.limit = this.totalCount;
    if (this.jobsType == "industry") {
      this.getJobs(this.extraParams);
    } else if (this.jobsType == "search") {
      this.getSearchData(JSON.parse(this.extraParams));
    } else {
      this.getAppliedJobs();
    }
  }

  jobSalary(job: any): string {
    let salary = "";
    if (job?.price)
      salary = job?.price + "/";
    else if (job?.maximum && job?.minimum)
      salary = job?.minimum + "-$" + job?.maximum + "/";
    else
      salary = job?.minimum + job?.maximum;
    if (job?.rate)
      return "$" + salary + "" + job?.rate.split(" ")[1];
    else
      return "$" + salary;
  }

  getJobDetail() {
    this.api.getData(apiUrl._getJobDetail + "/" + this.jobID, "").subscribe(async (res) => {
      this.jobDetailsData = res.data;
      this.noData = true;
    }, err => { console.log(err.error.message, "errr") })
  }

  goToJobDetail(jobId: string) {
    this.jobID = jobId;
    this.router.navigate(["/job-roles/role/" + this.jobID], { queryParams: { type: this.jobsType, extras: this.extraParams } });
    this.getJobDetail();
  }

  applyJob(jobId: string) {
    this.jobApplyService.openScreeningQuestionModal(jobId);
  }

  withdrawJob(jobId: string) {
    this.jobApplyService.withdrawJob(jobId);
  }

  public saveUnsaveJob(job: any, sectionType: number) {
    if (job.saveStatus == 0) {
      this.api.postData(apiUrl._saveUnsaveJob, { "jobPostId": job.id }).subscribe((res) => {
        if (sectionType == 2) {
          var findJobRef = this.jobsData.find((x) => (x?.job_post?.id || x.id) == this.jobID);
          if (findJobRef)
            if (findJobRef.job_post)
              findJobRef.job_post.saveStatus = 1;
            else
              findJobRef.saveStatus = 1;
        }
        if (job.id == this.jobDetailsData.JobPost.id)
          this.jobDetailsData.JobPost.saveStatus = 1;
        job.saveStatus = 1;
      });
    } else {
      this.api.deleteData(apiUrl._saveUnsaveJob, { "jobPostId": job.id }).subscribe((res) => {
        if (sectionType == 2)
          if (sectionType == 2) {
            var findJobRef = this.jobsData.find((x) => (x?.job_post?.id || x.id) == this.jobID);
            if (findJobRef)
              if (findJobRef.job_post)
                findJobRef.job_post.saveStatus = 0;
              else
                findJobRef.saveStatus = 0;
          }
        if (job.id == this.jobDetailsData.JobPost.id)
          this.jobDetailsData.JobPost.saveStatus = 0;
        job.saveStatus = 0;
      });
    }
  }

  dateInMilisecond(date) {
    const d1 = new Date(date)
    const miliSecond = d1.getTime();
    return miliSecond
  }
}
